import React from 'react';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { HOME_PADDER } from 'types/morph.pagePosition.constants';

const HomePadder = props => {
  const atr = getViewModuleTrackingAttributes(
    HOME_PADDER,
    props.modulePosition,
  );
  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);
  return (
    <>
      {seenPixel}
      <div className="HomePadder margB48 m-margB16" />
    </>
  );
};

export default HomePadder;
